<template>
  <div id="app">
  <section id="store" class="about">
    <div class="about-decor">
      <div class="about-circle1"><img :src='"../../assets/images/team1-blue.png"' alt="team1"></div>
      <div class="about-circle2"><img :src='"../../assets/images/main-banner1-blue.png"' alt="banner1"></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-sm-12 mrgn-md-top">
              <h2 class="title">{{ $t(`offer.store.title1`) }} <span>{{ $t(`offer.store.title2`) }}</span>
              </h2>
            </div>
            <div v-for="i in [1,2,3,4]" :key="i" class="col-12 col-md-6">
              <ul class="feature-style">
                <li>
                  <div class="feature-subtitle">
                    <h3>{{ $t(`offer.store.text.${i}.title`) }}</h3>
                  </div>
                  <div>
                    <p>{{ $t(`offer.store.text.${i}.text`) }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 d-medium-none">
          <div>
            <div class="about-right" style="padding: 20%">
              <div class="about-phone">
                <img :src='"../../assets/images/mockups/appsMockupRight.png"' class="img-fluid" alt="aboutus">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "Store"
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .feature-style li {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offerPage/store.vue